import { formatLabel, compareId } from "helpers/securities"

export const compareSecurity = (item1, item2) => {
  if (item1.assetClass === "index") {
    return item1.indexId === item2.indexId
  }
  return compareId(item1, item2)
}

export const convertUnifiedSearchItemToFilterItem = (item) => {
  const { assetClass, country, exchange, ticker, internalId } = item
  const value = formatLabel(item)
  let security = { assetClass, value, label: value }
  if (assetClass === "index") {
    security = { ...security, id: ticker, indexId: ticker }
  } else {
    security = { ...security, ticker, country, mic: exchange, internalId }
  }
  return security
}
